(function () {
  // CARD SLIDERS START hp-product-slider
  const sliderSections = document.querySelectorAll(".product-slider");

  // console.log("sliderSections --->", sliderSections);

  const sliders = Array.from(sliderSections).map((container) => {
    const next = container.querySelector(".slider-navigation .next");
    const prev = container.querySelector(".slider-navigation .prev");
    return new Swiper(container.querySelector(".swiper"), {
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      slidesPerView: 1.8,
      spaceBetween: 16,
      breakpoints: {
        540: { slidesPerView: 2.8 },
        990: { slidesPerView: 3 },
        1200: { slidesPerView: 4 },
        1400: { slidesPerView: 5 },
      },
    });
  });

  // CARD SLIDERS START hp-product-slider

  // iconed-card-slider START
  const iconedCardSwipers = document.querySelectorAll(".iconed-card-swiper");

  // console.log("iconedCardSwipers --->", iconedCardSwipers);
  
  iconedCardSwipers.forEach((item) => {

    // console.log("item --->", item);
    item.style.display = "block !important";
    
    const swiper = new Swiper(item, {
      slidesPerView: 2,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1050: {
          slidesPerView: 4,
        },
        1300: {
          slidesPerView: 5,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });
  // iconed-card-slider END

  // hp-mobile-app START
  {
    const mobileAppSwiperContainer =
      document.querySelector(".mobile-app-swiper");
    const mobileAppSwiperThumbnailContainer = document.querySelector(
      ".mobile-app-thumbnail"
    );
    const itemCount = mobileAppSwiperThumbnailContainer.dataset.slideCount;
    const mobileAppSwiper = new Swiper(mobileAppSwiperContainer, {});
    const mobileAppThumbnailSwiper = new Swiper(
      mobileAppSwiperThumbnailContainer,
      {
        slidesPerView: 1.5,
        spaceBetween: 10,
        breakpoints: {
          990: {
            grid: {
              rows: Number(itemCount),
            },
            slidesPerView: 1,
            spaceBetween: 16,
          },
        },
      }
    );

    mobileAppSwiper.on("activeIndexChange", (swiper) => {
      const idx = swiper.activeIndex;
      mobileAppThumbnailSwiper.slideTo(swiper.activeIndex);
      const activated = mobileAppThumbnailSwiper.slides.find((item) => {
        return item.classList.contains("activated");
      });
      activated.classList.toggle("activated");
      mobileAppThumbnailSwiper.slides[idx].classList.toggle("activated");
    });

    mobileAppSwiperThumbnailContainer
      .querySelectorAll(".swiper-slide")
      .forEach((slide, idx) => {
        slide.addEventListener("click", (item) => {
          mobileAppSwiper.slideTo(idx);
          console.log("test");
        });
      });
  }
  // hp-mobile-app END

  // IFRAME BUG FIX START
  const ytEmbeds = document.querySelectorAll("iframe[data-yt-src]");
  ytEmbeds.forEach((ytEmbed) => {
    const dataSrc = ytEmbed.dataset.ytSrc;
    ytEmbed.src = dataSrc;
  });
  // IFRAME BUG FIX END

})();
